import z from 'zod'

export const FirstSourceEventDTOScheme = z.object({
	active_date_from: z.string().nullable().optional(),
	active_date_to: z.string().nullable().optional(),
	date: z.string().nullable().optional(),
	id: z.string().nullable().optional(),
	name: z.string().nullable().optional(),
	picture: z.string().nullable().optional(),
	preview: z.string().nullable().optional(),
	url: z.string().nullable().optional(),
	detail: z.string().nullable().optional()
})

export type FirstSourceEventDTO = z.output<typeof FirstSourceEventDTOScheme>
